// Project-reports API client — wraps the /api/projects/{id}/reports endpoints
// the backend exposes for storing the generated Selection / Config / Submittal
// PDFs.
//
// Why store the reports at all?
// The Submittal tab used to re-generate every PDF on compile, which (for a
// 50-room project) meant capturing 50 RoomReportPage canvases via html2canvas
// — slow and CPU-heavy. By persisting the PDF after the engineer generates it
// in the Summary / Configurator tab, the Submittal tab just downloads the
// already-compiled bytes and merges them.

import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// List the stored reports for a project. Returns array of:
//   { id, project_id, kind, filename, size_bytes, generated_at,
//     generated_by_email }
export async function listProjectReports(projectId) {
  const res = await axios.get(`${API}/projects/${projectId}/reports`);
  return res.data || [];
}

// Upload (replace) a report. `kind` ∈ {"selection","config","submittal"}.
// Returns the same ReportOut shape as listProjectReports.
export async function uploadProjectReport(projectId, kind, blob, filename) {
  const fd = new FormData();
  fd.append("kind", kind);
  fd.append("file", blob, filename);
  const res = await axios.post(`${API}/projects/${projectId}/reports`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

// Download a stored report as a Blob. Uses native fetch (not axios) so that
// emergent-main.js's XHR patch doesn't intercept the blob response and throw
// an InvalidStateError when trying to read responseText on a blob transfer.
export async function downloadProjectReport(reportId) {
  const token = sessionStorage.getItem("zamba_token");
  const res = await fetch(`${API}/project-reports/${reportId}/download`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    cache: "no-store",
  });
  if (!res.ok) throw new Error(`Download failed: ${res.status} ${res.statusText}`);
  return res.blob();
}

export async function deleteProjectReport(reportId) {
  await axios.delete(`${API}/project-reports/${reportId}`);
}
